import Left from "@repo/icons/default/Left";
import {
  createFileRoute,
  useNavigate,
  useRouter,
  useSearch,
} from "@tanstack/react-router";
import { useState } from "react";
import type { ReactElement } from "react";
import { CpsButton, CpsCheckboxGroup, CpsCheckboxV2 } from "corpus";
import {
  HeaderButton,
  HeaderRoot,
  HeaderTitle,
} from "@/components/ui/layout/header/header";
import { Page } from "@/components/ui/layout/page/page";
import {
  type PatientPaymentsPageSearchSchema,
  patientPaymentsPageSearchSchema,
} from "@/lib/form-schemas/patient-payments-page-search-schema";

const FilterPaymentMethods = (): ReactElement => {
  const navigate = useNavigate();
  const router = useRouter();

  const navigateBack = (): void => {
    void router.navigate({
      to: "/settings/payments/patient-payments",
      search: { ...searchParams, back: (searchParams.back ?? 0) + 2, action: undefined },
    });
  };

  const searchParams = useSearch({
    from: "/settings/payments/patient-payments/filters/filter-payment-methods",
  });

  const [paymentMethodsSelected, setPaymentMethodsSelected] = useState<string[]>(
    searchParams.paymentMethods ?? [],
  );

  const handlePaymentMethodsChange = (values: string[]): void => {
    setPaymentMethodsSelected(values);
  };

  const handleSubmit = (): void => {
    const newSearch: PatientPaymentsPageSearchSchema = {
      ...searchParams,
      back: (searchParams.back ?? 0) + 1,
      paymentMethods: paymentMethodsSelected,
    };
    void navigate({
      to: "/settings/payments/patient-payments",
      search: newSearch,
      replace: true,
    });
  };

  return (
    <>
      <HeaderRoot>
        <HeaderButton onClick={navigateBack} align="start" icon={Left} />
        <HeaderTitle title="Filtro de métodos de pagamento" align="center" />
      </HeaderRoot>
      <Page className="flex flex-col justify-between">
        <CpsCheckboxGroup
          name="PaymentMethods-checkbox-group"
          onChange={handlePaymentMethodsChange}
        >
          <CpsCheckboxV2
            value="pix"
            label="Pix"
            checked={paymentMethodsSelected.includes("pix")}
          />
          <CpsCheckboxV2
            value="credit_card"
            label="Crédito"
            checked={paymentMethodsSelected.includes("credit_card")}
          />
          <CpsCheckboxV2
            value="debit_card"
            label="Débito"
            checked={paymentMethodsSelected.includes("debit_card")}
          />
        </CpsCheckboxGroup>
        <CpsButton color="secondary" fullWidth onClick={handleSubmit}>
          Aplicar filtros
        </CpsButton>
      </Page>
    </>
  );
};

export const Route = createFileRoute(
  "/settings/payments/patient-payments/filters/filter-payment-methods",
)({
  component: FilterPaymentMethods,
  validateSearch: patientPaymentsPageSearchSchema,
});
